module.exports = __webpack_public_path__ + "media/images/card/glyph-1-cba2c5db2992d2de77bb68516d63ac29.svg";